import { render } from "./UserMenu.vue?vue&type=template&id=0b1c8396&scoped=true&ts=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=0b1c8396&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1c8396"]])

export default __exports__